var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11285_2444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 35.0001H2.50002C1.11925 35.0001 0 33.8808 0 32.5001C0 31.1194 1.11925 30.0001 2.50002 30.0001H37.5001C38.8808 30.0001 40.0001 31.1194 40.0001 32.5001C40 33.8808 38.8808 35.0001 37.5 35.0001ZM37.5 22.5H2.50002C1.11925 22.5 0 21.3808 0 20.0001C0 18.6194 1.11925 17.5001 2.50002 17.5001H37.5001C38.8808 17.5001 40.0001 18.6193 40.0001 20.0001C40.0001 21.3809 38.8808 22.5 37.5 22.5ZM37.5 10H2.50002C1.11925 10 0 8.88079 0 7.50002C0 6.11925 1.11925 5 2.50002 5H37.5001C38.8808 5 40.0001 6.11925 40.0001 7.50002C40.0001 8.88079 38.8808 10 37.5 10Z",
    fill: "url(#paint0_linear_11285_2444)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11285_2444",
    x1: 5.02535,
    y1: 5.58813,
    x2: 33.3764,
    y2: 35.0592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11285_2444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.49d44fef5c1f2ffa8a6d384361821681.svg";
export { ForwardRef as ReactComponent };